module.exports = __webpack_public_path__ + "img/logo-admins-egypt.1265ec3e.png";